// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 课程服务配置列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /vip-config/tj/list */
export async function vipConfigTjListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListVipConfigTjResp>('/vip-config/tj/list', {
    method: 'GET',
    ...(options || {}),
  });
}
